import { Form } from "../Support/Form";
import { axios } from "../Support/axios";

export class Payment extends Form {

    constructor(data = {}) {
        super(data);
    }

    index(append = false) {
        let self = this;

        return new Promise((resolve, reject) => {
            let uri = '/api/payment?page=' + self.page;

            axios.get(uri, self.data)
                .then(response => {
                    let result = response.data;

                    self.processIndexData(result, append);

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }

    actionPayment(event, index) {
        let self = this;
        let payment = self.index_data.data[index];

        return new Promise((resolve, reject) => {
            axios.patch('/api/payment/' + payment.id + '/action', {
                    action: event.target.value > 0
                })
                .then(response => {
                    self.index_data.data[index] = response.data.data;

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }

}
